import NoteItem from "../Molecules/NoteItem";
import styles from "../../Styles/Notes.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";

const Notes = ({ selected, notes }) => {
  const filterTypeState = useSelector((state) => state.note.filterType);
  const filterInputState = useSelector((state) => state.note.filterInput);

  const selectedNoteHandler = (value) => {
    selected(value);
  };

  return (
    <motion.div className={styles.notes_layout}>
      <AnimatePresence>
        {filterInputState === ""
          ? notes.map((note, index) => (
              <NoteItem
                index={index}
                key={note.id}
                title={note.title}
                text={note.text}
                id={note.id}
                selectedNote={selectedNoteHandler}
              />
            ))
          : filterTypeState === "Text"
          ? notes
              .filter((i) =>
                i.text.toLowerCase().includes(filterInputState.toLowerCase())
              )
              .map((note, index) => (
                <NoteItem
                  index={index}
                  key={note.id}
                  title={note.title}
                  text={note.text}
                  id={note.id}
                  selectedNote={selectedNoteHandler}
                />
              ))
          : notes
              .filter((i) =>
                i.title
                  .toLowerCase()
                  .includes(filterInputState.toLowerCase())
              )
              .map((note, index) => (
                <NoteItem
                  index={index}
                  key={note.id}
                  title={note.title}
                  text={note.text}
                  id={note.id}
                  selectedNote={selectedNoteHandler}
                />
              ))}
      </AnimatePresence>
    </motion.div>
  );
};
export default Notes;
